import Env from '../base/env';
import Channels from '../base/channels';
import gsap from 'gsap';

class Launcher {
  constructor() {
    // Flags
    this.NO_INTRO = true;
    this.LAUNCHED = false;
    // FNs
    this.setup();
  }

  noLaunch() {
    gsap.delayedCall(0.25, () => {
      Env.$html.classList.add('ui-ready');
      Channels.emit('launcher::exit');
      this.LAUNCHED = true;
    });
    gsap.delayedCall(0.4, () => {
      Env.$html.classList.add('ui-finalized');
    });
  }

  setup() {
    if (this.NO_INTRO) {
      this.noLaunch();
    } else {
      console.log('anim launch');
    }
  }
}

export default Launcher;
